<template>
  <div class="dashboard">
    <mainmenu selected="dashboard"></mainmenu>
    <div class="container-fluid">
      <h1>{{$t('dashboard.page_title')}}</h1>

      
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>Filters</span>
        </div>
        <div>
          <el-form :inline="true" :model="Filters">
            <el-form-item :label="$t('dashboard.article_code')">
              <el-autocomplete class="inline-input" v-model="Filters.ArticleCode" :fetch-suggestions="queryCodes"></el-autocomplete>
            </el-form-item>

            <el-form-item :label="$t('dashboard.quantity_range')" >
              <el-input-number v-model="Filters.MinQuantity"></el-input-number>
              -
              <el-input-number v-model="Filters.MaxQuantity"></el-input-number>
            </el-form-item>

            <el-form-item :label="$t('dashboard.category')" >
              <el-select v-model="Filters.IdCategory">
                <el-option :label="$t('all')" :value="-1" :key="-1"></el-option>
                <el-option v-for="c in Categories" :label="c.Name" :value="c.Id" :key="c.Id"></el-option>
              </el-select>
            </el-form-item>
            
            <el-form-item :label="$t('dashboard.factory_code')">
              <el-select v-model="Filters.IdFactory">
                <el-option :label="$t('all')" :value="-1" :key="-1"></el-option>
                <el-option 
                        v-for="f in Factories"
                        :label="f.ShortCode"
                        :key="f.Id"
                        :value="f.Id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="refresh_info">{{$t('filter')}}</el-button>
              <el-button type="warning" @click="resetFilters">{{$t('reset')}}</el-button>
            </el-form-item>
            
          </el-form>
        </div>
      </el-card>


       <el-table :data="Results" style="width: 100%; margin-top: 50px" v-loading="tableLoadingVisible" @sort-change="on_sort">

          <el-table-column sortable prop="Id" :label="$t('dashboard.unique_id')" width="80"></el-table-column>
          <el-table-column sortable prop="FactoryCode" :label="$t('dashboard.factory_code')" width="140"></el-table-column>
          <el-table-column sortable prop="SellerName" :label="$t('dashboard.seller_name')" width="140"></el-table-column>
          
          <el-table-column :label="$t('dashboard.article_info')">
            <template slot-scope="scope">
                <strong>{{scope.row.ArticleNumber}}</strong> - {{scope.row.ProductName}} <br/>
                <em>{{scope.row.ProductCategory}}</em> <br/>
                <p class="small">{{scope.row.ProductDescription}}</p>
            </template>
          </el-table-column>

          <el-table-column :label="$t('dashboard.product_status')" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.ProductStatus === 'new'">{{$t('dashboard.new')}}</span>
              <span v-if="scope.row.ProductStatus === 'used'">{{$t('dashboard.used')}}</span>
            </template>
          </el-table-column>
          <el-table-column sortable prop="Quantity" :label="$t('dashboard.quantity')" width="100"></el-table-column>
          <el-table-column :label="$t('dashboard.price')" width="120">
            <template slot-scope="scope">
                {{scope.row.Price|format_money}} &euro;
            </template>
          </el-table-column>
          <el-table-column fixed="right" :label="$t('dashboard.operations')" width="120">
            <template slot-scope="scope">
              <div v-if="$rights.is_not_guest()">
                <el-button @click="show_buy_dialog(scope.row)" type="text" size="small">{{$t('dashboard.order')}}</el-button>
              </div>
            </template>
          </el-table-column>
      </el-table>

      <el-pagination
          @size-change        = "refresh_info"
          @current-change     = "refresh_info"
          :page-size.sync     = "PaginationInfo.PerPage"
          :current-page.sync  = "PaginationInfo.Page"
          :total              = "PaginationInfo.RowCount"
          layout              = "pager">
      </el-pagination>

      <buy-dialog ref="buyDialog" @neworder="refresh_info"></buy-dialog>

    </div>
  </div>
</template>

<script>
import MainMenu from "./../widgets/MainMenu";
import settings from "./../backend/LocalSettings";
import BuyDialog from "./../views/dialogs/BuyDialog"

export default {
  name: "dashboard",
  components: {
    "mainmenu": MainMenu,
    "buy-dialog": BuyDialog
  },
  data () {
    return { 
      tableLoadingVisible: false,
      Results: [],
      Filters: { ArticleCode: "", MinQuantity:"", MaxQuantity:"99999999999", IdCategory:-1, IdFactory:-1, Status: "all" },
      OrderBy: { Column:"", Order:"ascending" },
      PaginationInfo: { Page: 1, PerPage: 20, RowCount: 0, PageSizes: [20, 50, 100] },
      Categories: [],
      Factories:[],
    }
  },
  methods: {
    resetFilters: function(){
      this.Filters = { ArticleCode: "", MinQuantity:"", MaxQuantity:"99999999999", IdCategory:-1, IdFactory:-1, Status: "all" };
      this.refresh_info();
    },
    show_buy_dialog: function(item){
      this.$refs.buyDialog.show_me(item);
    },
    on_sort: function(data){
      if( data.prop != null ){
        this.OrderBy.Column = data.prop;
        this.OrderBy.Order  = data.order == "ascending" ? "ASC" : "DESC";
      }
      else
      {
        this.OrderBy.Column = "";
        this.OrderBy.Order  = "";
      }
      this.refresh_info();
    },
    get_info: async function() {
      this.loadingVisible      = true;
      var             response = await this.$http.post('dashboard/get_info',  {} );
      this.tableLoadingVisible = false;
      if( settings.verify_response(response, this.$rights)) 
      {
        this.Categories = response.body.Categories;
        this.Factories  = response.body.Factories;
        this.refresh_info();
      } else {
        this.$router.push("/");
      }
    },
    refresh_info: function() {
      this.loadingVisible = true;
      this.$http
          .post('dashboard/refresh_info',  { OrderBy: this.OrderBy, Filters: this.Filters, PaginationInfo: this.PaginationInfo } )
          .then(function (response) {
            this.tableLoadingVisible = false;
            if( settings.verify_response(response, this.$rights)) {
              this.Results = response.body.Results;
              this.PaginationInfo = response.body.PaginationInfo;
            } else {
              this.$router.push("/");
            }
          }); 
    },
    queryCodes: function(queryString, cb){
      this.loadingVisible = true;
      this.$http
          .post('products/search_code',  { query: queryString } )
          .then(function (response) {
            this.tableLoadingVisible = false;
            if( settings.verify_response(response, this.$rights)) {
              cb(response.body.Results);
            } else {
              this.$router.push("/");
            }
          }); 
    },
    logout: function() {
      settings.logout();
      this.$router.push("/");
    }
  },
  mounted: function() {
    this.get_info();
  }
};
</script>

<style lang="less" scoped>

</style>